export const AGENCY_BILLING_LOCKED_MESSAGE =
  "Tu agencia administra la facturación de este workspace. Contacta a tu agencia para cambiar de plan o comprar.";

export const AGENCY_BILLING_CONTACT_LABEL = "Contacta a tu agencia";

export const AGENCY_DISSOCIATION_LOCKED_MESSAGE =
  "Tu agencia administra este workspace y su facturación. Para desasociarlo, contacta a tu agencia.";

export interface AgencyBillingViewer {
  billingManagedByAgency: boolean;
  isMatrixDelegate: boolean;
  isSuperAdmin: boolean;
}

export function isBillingLockedForViewer({
  billingManagedByAgency,
  isMatrixDelegate,
  isSuperAdmin,
}: AgencyBillingViewer): boolean {
  return billingManagedByAgency && !isMatrixDelegate && !isSuperAdmin;
}

export const AGENCY_AGENT_LIMIT_MESSAGE = "Para agregar más agentes, contacta a tu agencia.";
